import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Image,
  Row,
  Col,
  Container,
  Form,
  CloseButton,
  ListGroup,
  Badge
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
if (typeof document !== 'undefined') {
  const styleId = 'slide-right-cart-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
    
    .modal.fade .modal-dialog.slide-right {
    transform: translateX(100%);
    transition: transform 0.3s ease-out;
  }
  .modal.show .modal-dialog.slide-right {
    transform: translateX(0);
  }
  .modal.slide-right-modal .modal-dialog {
    position: fixed;
    right: 0;
    top: 0;
    margin: 0;
    height: 100%;
    max-width: 700px;
    width: 100%;
  }
  .modal.slide-right-modal .modal-content {
    height: 100%;
    border-radius: 0;
    border: none;
    overflow-y: auto;
  }
      .cart-item-title {
        font-weight: 600;
        font-size: 0.95rem;
        margin-bottom: 0.3rem;
      }
      .cart-item-details {
        font-size: 0.85rem;
        color: #6c757d;
      }
      .shipping-badge {
        background-color: #d4edda;
        color: #155724;
        padding: 0.35rem 0.65rem;
        border-radius: 4px;
        font-size: 0.8rem;
        font-weight: 500;
      }

      /* Hide scrollbar */
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
      .hide-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
    @media (max-width: 767px) {
    .modal.slide-right-modal .modal-dialog {
      width: 95% !important;
      margin-left: auto;
      margin-right: 0;
    }
  }     
    `;
    document.head.appendChild(style);
  }
}

const QuickViewModal = ({ show, onHide }) => {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const fetchCart = async () => {
    const token = getAuthToken();

    if (!token) {
      console.warn("No auth token found, user may need to login.");
      setCartItems([]);
      return;
    }

    try {
      const res = await axios.get(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.status === "success") {
        const mappedItems = res.data.data.map((item) => {
          // ✅ primary_image is an object, not an array
          const imagePath = item.product?.primary_image?.image_path;
          const imageUrl = imagePath
            ? `https://vantara.datacubeglobal.com/storage/${imagePath}`
            : "https://via.placeholder.com/70"; // fallback image

          return {
            id: item.cart_id,
            title: item.product?.product_name || "Unnamed Product",
            product_id: item.product.encrypted_product_id,
            variant: "",
            price: parseFloat(item.product?.special_price || 0),
            quantity: item.quantity,
            image: imageUrl,
          };
        });


        setCartItems(mappedItems);
        // console.log(mappedItems,'jjjj');

      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };
  useEffect(() => {
    if (!show) return;

    fetchCart();
  }, [show]);









  useEffect(() => {
    if (!show) return;

    axios
      .get("https://vantara.datacubeglobal.com/api/random_products")
      .then((res) => {
        if (res.data.status === "success") {
          const mapped = res.data.data.map((p) => {
            let displayPrice = 0;

            switch (p.primary_price) {
              case "mrp":
                displayPrice = parseFloat(p.mrp);
                break;
              case "special_price":
                displayPrice = parseFloat(p.special_price);
                break;
              case "retail":
                displayPrice = parseFloat(p.retail);
                break;
              case "wholesale":
                displayPrice = parseFloat(p.wholesale);
                break;
              default:
                displayPrice = parseFloat(p.mrp);
            }

            return {
              id: p.product_id,
              title: p.product_name,
              price: displayPrice,
              img: `https:\/\/vantara.datacubeglobal.com\/storage/${p.primary_image}`,
              is_wishlisted: p.is_wishlisted || false,
            };
          });

          setRecommended(mapped);
        }
      })
      .catch((err) => console.error("Error fetching random products:", err));
  }, [show]);




  const removeItem = async (product_id) => {
    const token = getAuthToken();
    if (!token) return;



    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart/remove-item",
        { product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("📩 API Response:", res.data);

      if (res.data.status === "success") {
        fetchCart();
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);
  // Add to Cart API Integration
  const handleAddToCart = async (product) => {
    const token = getAuthToken();

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login to add items to your cart.",
      });
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          product_id: product?.id || product?.product_id,
          quantity: 1,
          options: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Added to Cart!",
          text: `${product.title} has been added to your cart.`,
          timer: 1200,
          showConfirmButton: false,
        });
        fetchCart(); // 🔄 Refresh cart list
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.data.message || "Failed to add product to cart.",
        });
      }
    } catch (err) {
      console.error("Add to cart error:", err);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to add item to cart. Please try again later.",
      });
    }
  };


  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="slide-right-modal fade"
      dialogClassName="slide-right"
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header className="border-bottom px-4 pt-4 pb-3">
        <Modal.Title className="h5 mb-0">Shopping Cart</Modal.Title>
        <CloseButton onClick={onHide} />
      </Modal.Header>


      <Modal.Body className="p-0" style={{ height: "100%" }}>
        {/* MOBILE VIEW ONLY */}
        <div className="d-block d-md-none" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Top: You May Also Like - Horizontal Scroll */}
          <div className="px-3 py-2 flex-shrink-0">
            <h6 className="mb-3">You May Also Like</h6>
            {/* <div
              className="d-flex overflow-x-auto pb-2 hide-scrollbar"
              style={{ gap: "10px", WebkitOverflowScrolling: "touch" }}
            >
              {recommended.map((p) => (
                <div
                  key={p.id}
                  className="flex-shrink-0 text-center"
                  style={{ minWidth: "100px" }}
                >
                  <Image
                    src={p.img}
                    fluid
                    onClick={() => {
                      navigate(`/productDetails/${p.id}`);

                    }}
                    className="mb-2 rounded"
                    style={{ maxHeight: "120px", objectFit: "cover" }}
                  />
                  <div className="small">{p.title}</div>
                  <div className="fw-semibold" style={{ color: "#7c0046" }}>₹&nbsp;{p.price}</div>
                </div>
              ))}
            </div> */}
            <div
              className="d-flex overflow-x-auto pb-2 hide-scrollbar"
              style={{
                gap: "12px",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {recommended.map((p) => (
                <div
                  key={p.id}
                  className="flex-shrink-0 text-center p-2 rounded shadow-sm"
                  style={{
                    width: "140px",
                    background: "#fff",
                    border: "1px solid #eee",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "250px",
                  }}
                >
                  {/* ✅ Product Image */}
                  <div style={{ flex: "0 0 auto" }}>
                    <Image
                      src={p.img}
                      fluid
                      onClick={() => navigate(`/productDetails/${p.id}`)}
                      className="mb-2 rounded"
                      style={{
                        height: "110px",
                        width: "100%",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                    />
                  </div>


                  <div
                    className="small mb-1"
                    style={{
                      fontWeight: "500",
                      color: "#333",
                      minHeight: "38px",
                      overflow: "hidden",
                      textAlign: "center",
                      whiteSpace: "normal",
                      lineHeight: "1.2",
                    }}
                  >
                    {p.title}
                  </div>


                  <div
                    className="fw-semibold mb-2"
                    style={{
                      color: "#7c0046",
                      fontSize: "0.9rem",
                      lineHeight: "1",
                    }}
                  >
                    ₹&nbsp;{p.price}
                  </div>


                  <button
                    type="button"
                    className="btn btn-sm w-100 fw-semibold"
                    style={{
                      backgroundColor: "#124F14",
                      color: "#fff",
                      borderRadius: "20px",
                      fontSize: "13px",
                      padding: "6px 0",
                      marginTop: "auto",
                    }}
                    onClick={() => handleAddToCart(p)}
                  >
                    <i className="bi bi-cart-plus me-1"></i> Add
                  </button>
                </div>
              ))}
            </div>



          </div>



          <div className="px-4 py-3" style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Shopping Cart</h5>
              <CloseButton onClick={onHide} />
            </div>


            <div>
              {cartItems.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  Your cart is empty
                </div>
              ) : (
                cartItems.map((item) => (
                  <div key={item.id} className="d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <Image src={item.image} fluid rounded style={{ width: "60px", height: "60px", objectFit: "cover" }} />
                      <div className="ms-3">
                        <div className="small fw-bold">{item.title}</div>
                        <div className="small text-muted">{item.variant}</div>
                        <div className="small text-muted mt-1">
                          {item.quantity} × {item.price.toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <div className="text-end">
                      <CloseButton style={{ fontSize: "0.7rem" }} onClick={() => removeItem(item.product_id)} />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Bottom: Sticky Subtotal */}
          <div
            className="px-4 py-3 border-top bg-white flex-shrink-0"
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
              zIndex: 10,
              boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <div className="d-flex justify-content-between mb-2">
              <span className="fw-bold text-dark">Subtotal</span>

              <span>{subtotal.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Shipping</span>
              <span className="text-success">Free</span>
            </div>

            <Form.Check
              type="checkbox"
              id="terms-agree"
              label="I agree with Terms & Conditions"
              checked={agreeTerms}
              onChange={(e) => setAgreeTerms(e.target.checked)}
              className="mb-3"
            />

            <div className="d-flex gap-2">
              <Button
                style={{
                  backgroundColor: "#7c0046",
                  color: "#fff",
                }}
                size="sm"
                disabled={!agreeTerms}
                onClick={() => navigate("/checkout")}
                className="flex-grow-1"
              >
                View Cart
              </Button>
              <Button variant="outline" style={{
                backgroundColor: "#124f14  ",
                color: "#fff",
              }} size="sm" className="flex-grow-1">
                Check Out
              </Button>
            </div>

            <div className="text-center mt-2">
              <Button variant="link" size="sm" onClick={onHide}>
                OR CONTINUE SHOPPING
              </Button>
            </div>
          </div>
        </div>

        {/* DESKTOP VIEW ONLY */}
        <div className="d-none d-md-block" style={{ height: "100vh" }}>
          <div className="d-flex" style={{ height: "90%" }}>
            {/* LEFT COLUMN - You May Also Like (SCROLLABLE) */}
            {/* <div
              className="hide-scrollbar"
              style={{
                width: "35%",
                padding: "1rem",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h6 className="mb-3">You May Also Like</h6>
              {recommended.map((p) => (
                <div key={p.id} className="mb-4 text-center">
                  <Image src={p.img} fluid className="mb-2 rounded" onClick={() => {
                    navigate(`/productDetails/${p.id}`);

                  }} />
                  <div className="small">{p.title}</div>
                  <div className="fw-semibold" style={{ color: "#7c0046" }}>₹&nbsp;{p.price}</div>
                  <hr />
                </div>
              ))}
            </div> */}
            <div
              className="hide-scrollbar"
              style={{
                width: "35%",
                padding: "1rem",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h6 className="mb-3">You May Also Like</h6>

              {recommended.map((p) => (
                <div
                  key={p.id}
                  className="mb-4 text-center p-2 rounded shadow-sm"
                  style={{
                    background: "#fff",
                    border: "1px solid #eee",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <Image
                    src={p.img}
                    fluid
                    className="mb-2 rounded"
                    onClick={() => navigate(`/productDetails/${p.id}`)}
                    style={{
                      cursor: "pointer",
                      objectFit: "cover",
                      maxHeight: "140px",
                      width: "100%",
                    }}
                  />
                  <div
                    className="small text-truncate mb-1"
                    style={{ fontWeight: "500", color: "#333" }}
                  >
                    {p.title}
                  </div>
                  <div className="fw-semibold mb-2" style={{ color: "#7c0046" }}>
                    ₹&nbsp;{p.price}
                  </div>


                  <button
                    type="button"
                    className="btn btn-sm w-100 fw-semibold"
                    style={{
                      backgroundColor: "#124F14",
                      color: "#fff",
                      borderRadius: "20px",
                      fontSize: "13px",
                      padding: "6px 0",
                    }}
                    onClick={() => handleAddToCart(p)}
                  >
                    <i className="bi bi-cart-plus me-1"></i> Add to Cart
                  </button>

                </div>
              ))}
            </div>




            <div className="d-flex flex-column" style={{ width: "70%", height: "100%" }}>

              <div className="bg-white px-4 py-3" style={{ flexShrink: 0 }}>

              </div>

              {/* SCROLLABLE CART ITEMS */}
              <div
                className="hide-scrollbar"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  padding: "0 1rem",
                }}
              >
                <ListGroup variant="flush">
                  {cartItems.length === 0 ? (
                    <ListGroup.Item className="text-center py-5 text-muted">
                      Your cart is empty
                    </ListGroup.Item>
                  ) : (
                    cartItems.map((item) => (
                      <ListGroup.Item key={item.id} className="px-3 py-3">
                        <Row className="align-items-center">
                          <Col xs={3}>
                            <Image src={item.image} alt='img' fluid rounded />
                          </Col>
                          <Col xs={9}>
                            <div className="cart-item-title">{item.title}</div>
                            <div className="cart-item-details mb-1">{item.variant}</div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="cart-item-details">
                                {item.quantity} X {item.price.toFixed(2)}
                              </div>
                              <CloseButton style={{ fontSize: "0.7rem" }} onClick={() => removeItem(item.product_id)} />
                            </div>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    ))
                  )}
                </ListGroup>
              </div>

              {/* Sticky bottom - subtotal */}
              <div
                className="px-4 py-3 border-top bg-white"
                style={{ flexShrink: 0 }}
              >
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-bold text-dark" style={{ fontSize: "1.500rem" }}>Subtotal</span>


                  <span className="fw-bold text-dark" style={{ fontSize: "1.500rem" }}>{subtotal.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span>Shipping</span>
                  <span className="text-success">Free</span>
                </div>

                {/* <Form.Check
                  type="checkbox"
                  id="terms-agree"
                  label="I agree with Terms & Conditions"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                  className="mb-3"
                /> */}

                <div className="d-flex gap-2">
                  <Button
                    variant="outline"
                    size="lg"
                    style={{
                      backgroundColor: "#7c0046",
                      color: "#fff",
                    }}
                    // disabled={!agreeTerms}
                    className="flex-grow-1"
                    onClick={() => {
                      onHide();
                      navigate("/checkout");
                    }}
                  >
                    View Cart
                  </Button>
                  <Button variant="outline" style={{
                    backgroundColor: "#124f14  ",
                    color: "#fff",
                    
                  }} size="lg" className="flex-grow-1"   onClick={() => {
                      onHide();
                      navigate("/proceedcheckout");
                    }}>
                    Check Out
                  </Button>
                </div>

                <div className="text-center mt-2">
                  <Button variant="link" onClick={() => navigate("/proceedcheckout")}>
                    OR CONTINUE SHOPPING
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default QuickViewModal;

